import React from 'react';

import { MobileUnavailable } from '@vk-hr-tek/ui/MobileUnavailable';

export const Substitutes = () => <MobileUnavailable />;
